import styled, { css } from "styled-components";
import { transparentize } from "polished";
import { IStyleProps } from "./interfaces";

export const StyledHero = styled.div`
    background: ${p => p.theme.c.boost};
    background-size: cover;
    background-position: center center;
    overflow: hidden;
    margin-top: 50px;
    position: relative;
`;

export const Background = styled.div`
    background-size: cover;
    background-position: center center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    ${p =>
        p.theme.sm.max(css`
            background-position: center;
            background-size: cover;
        `)}
    ${p =>
        p.theme.xs(css`
            background-size: cover;
            background-position: -56px bottom;
        `)}
`;

export const ChristmasBackground = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: 180%;
    background-position-y: -224px;
    background-position-x: -90px;
    ${p =>
        p.theme.md.only(css`
            background-position-y: -124px;
            background-position-x: -90px;
        `)}
    ${p =>
        p.theme.sm.only(css`
            background-position-y: -124px;
            background-position-x: 0px;
        `)}
    ${p =>
        p.theme.xs(css`
            background: none;
        `)}
    z-index: -1;
`;

export const HeroContent = styled.div<IStyleProps>`
    position: relative;
    width: 100%;
    background: linear-gradient(
        to right,
        ${p => transparentize(0.15, p.theme.c.boost)} 0%,
        ${p => transparentize(1, p.theme.c.white)} 75%
    );
    overflow: hidden;
    height: 100%;
    padding: 40px;
    box-sizing: border-box;
    padding-right: 200px;
    color: #eee;
    z-index: 0;

    ${p =>
        p.theme.sm.max(css`
            height: auto;
            padding: 16px;
            background: linear-gradient(
                to bottom,
                ${p => transparentize(0.64, p.theme.c.active)} 0%,
                ${p => transparentize(0.36, p.theme.c.active)} 100%
            );
        `)}

    h1 {
        font-size: ${p => p.locale === "el" ? 34 : 36}px;
        margin-top: 0;
        font-weight: 600;
        line-height: 1.4;
        color: ${p => p.theme.c.info};
        text-shadow: 1px 1px 2px ${p => p.theme.c.blackShadow3};
        ${p => p.theme.lg(css`
            width: ${(p.locale === "el" || p.locale === "nl") ? 570 : (p.locale === "lt" || p.locale === "ca") ? 630 : 500}px;
        `)}

        ${p => p.theme.md.only(css`
            width: 550px;
        `)}

        ${p =>
        p.theme.sm.max(css`
                font-size: 28px;
                text-align: center;
                width: auto;
            `)}
    }

    h2 {
        font-weight: 400;
        color: ${p => p.theme.c.whiteOnActive};
        text-shadow: 1px 1px 2px ${p => p.theme.c.blackShadow3};
        ${p =>
        p.theme.sm.min(css`
                width: 400px;
            `)}
        ${p =>
        p.locale === "el" && p.theme.lg(css`
                width: 500px;
            `)}
        ${p =>
        p.theme.sm.max(css`
                margin-left: auto;
                margin-right: auto;
                font-size: 20px;
                text-align: center;
                line-height: 30px;
            `)}
    }
`;

export const ButtonWrapper = styled.div`
    display: inline-block;
    margin-right: 20px;

    ${p =>
        p.theme.sm.max(css`
            display: block;
            text-align: center;
            margin-right: 0;
            margin-bottom: 10px;
        `)}
`;

// export const CreatedBy = styled.div`
//     font-weight: 300;
// `;

export const LaunchContainer = styled.div`
    display: inline-block;
    cursor: pointer;
    background-color: ${p => p.theme.c.pale};
    font-size: 26px;
    font-weight: 400;
    padding: 10px 24px;
    text-align: center;
    box-shadow: 5px 5px 6px 0 rgba(0, 0, 0, 0.17);
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    margin: 40px auto 24px -40px;
    padding-left: 40px;
    position: relative;
    border-radius: 0 8px 8px 0;
    padding-right: 62px;
    text-align: left;
    visibility: hidden;

    &.Visible {
        visibility: visible;
    }

    ${p => p.theme.md.min(css`
        width: 526px;
    `)}

    ${p =>
        p.theme.sm.max(css`
            display: block;
            font-size: 22px;
            padding: 8px 16px;
            padding-right: 82px;
            margin: 24px auto;
            border-radius: 8px;
        `)}

    ${p => p.theme.xs(css`
        border-radius: 8px 26px 26px 8px;
    `)}
`;

export const ToMemory = styled.a`
    font-size: 21px;
    font-weight: 400;
    padding: 10px 16px;
    text-align: center;
    box-shadow: 5px 5px 6px 0 rgba(0, 0, 0, 0.17);
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    margin: 40px auto 30px -40px;
    padding-right: 40px;
    position: absolute;
    top: 3px;
    right: 0;
    border-radius: 8px 0 0 8px;
    background-color: ${p => p.theme.c.memoryActive};
    ${p => p.theme.md.only(css`
        max-width: 340px;
    `)}
    ${p =>
        p.theme.sm.max(css`
            display: block;
            position: static;
            font-size: 17px;
            padding: 8px 16px;
            margin: 24px auto;
            border-radius: 8px;
        `)}
    .i-arrowback {
        color: ${p => p.theme.c.whiteOnActive};
        font-size: 32px;
        line-height: 10px;
        margin: -10px;
        margin-left: 0px;
        transform: scale(-1, 1);
        display: inline-block;
        position: relative;
        top: 7px;
        @media (max-width: 350px) {
            display: none;
        }
    }
`;

export const ToChoir = styled(ToMemory)`
    background-color: ${p => p.theme.c.choirActive};
    top: 66px;
`;

export const MorePlans = styled.div`
    font-size: 16px;
    margin-top: 18px;

    a.link {
        color: ${p => p.theme.c.whiteOnActive};
    }

    .i-chevron-right {
        /* width: 16px;
        height: 16px; */
        color: ${p => p.theme.c.whiteOnActive};
        display: inline-block;
        font-size: 16px;
        margin: -3px 4px;
        position: relative;
        top: 1px;
    }

    a.link:hover .i-chevron-right {
        font-weight: 600;
    }
`;

export const Meteor = styled.img`
    position: absolute;
    top: -110px;
    left: 390px;
    ${p =>
        p.theme.sm.max(css`
            display: none;
        `)}
`;

export const Star = styled.div`
    position: absolute;
    top: 132px;
    right: 182px;
    ${p =>
        p.theme.md.max(css`
            display: none;
        `)}
`;

export const LastChristmas = styled.a`
    display: block;
    ${p =>
        p.theme.md.min(css`
            position: absolute;
            top: 20px;
            right: 0;
            margin: auto;
        `)}
    color: ${p => p.theme.c.white};
    background-color: ${p => p.theme.c.info};
    font-size: 22px;
    font-weight: 400;
    padding: 8px 14px;
    text-align: center;
    box-shadow: 5px 5px 6px 0 rgba(0, 0, 0, 0.17);
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
`;

export const Arrow = styled.div`
    display: inline-block;
    transform: scale(-1, 1);
    .i-arrowback {
        margin: -10px 0px -14px -10px;
        color: ${p => p.theme.c.whiteOnActive};
        font-size: 44px;
        display: inline-block;
        line-height: 0;
        position: relative;
        top: 10px;
    }
`;

// export const HunIcon = styled.div`
//     position: absolute;
//     top: -18px;
//     right: -25px;
//     border-radius: 50px;
//     background: rgba(255, 255, 255, 0.2);
//     box-shadow: 0 0 40px 20px rgba(255, 255, 255, 0.25);
//     ${p => p.theme.sm.max(css`
//         right: -17px;
//         top: -23px;
//     `)}
//
//     ${p => p.theme.xs(css`
//         display: none;
//     `)}
//     img {
//         width: 100px;
//     }
// `;

export const Bell = styled.img`
    position: absolute;
    height: 62px;
    top: 288px;
    right: 215px;
    ${p =>
        p.theme.md.max(css`
            display: none;
        `)}
`;

export const Angel = styled.img`
    position: absolute;
    height: 62px;
    top: 339px;
    right: 292px;
    ${p =>
        p.theme.md.max(css`
            display: none;
        `)}
`;

export const Nutcracker = styled.img`
    position: absolute;
    height: 62px;
    top: 359px;
    right: 202px;
    ${p =>
        p.theme.md.max(css`
            display: none;
        `)}
`;

export const Raindear = styled.img`
    position: absolute;
    height: 62px;
    top: 313px;
    right: 145px;
    ${p =>
        p.theme.md.max(css`
            display: none;
        `)}
`;

export const Ding = styled.img`
    position: absolute;
    height: 54px;
    top: 378px;
    right: 122px;
    ${p =>
        p.theme.md.max(css`
            display: none;
        `)}
`;

export const SantaImage = styled.img`
    position: absolute;
    width: 130px;
    height: 130px;
    top: -40px;
    right: -40px;
    ${p =>
        p.theme.sm.max(css`
            display: none;
        `)
    }
`;

export const YearIcon = styled.div`
    position: absolute;
    top: 50%;
    right: -20px;
    transform: translateY(-50%);
    height: 72px;
    width: 72px;
    background-color: ${p => p.theme.c.active};
    box-shadow: inset 0 0 0 4px ${p => p.theme.c.boost};
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${p => p.theme.c.info};
    font-weight: 600;
    text-shadow: none;

    ${p => p.theme.sm.max(css`
        right: -6px;
    `)}
`;

export const Progress = styled.div`
    background-color: ${p => p.theme.c.info};
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    ${p => p.theme.sm.max(css`
        border-radius: 8px 0 0 8px;
    `)}
`;

export const ProgressTitle = styled.span`
    z-index: 1;
    position: relative;
    ${p => p.theme.xs(css`
        font-size: 18px;
    `)}
`;

export const Percent = styled.div`
    position: absolute;
    top: 50%;
    right: 60px;
    transform: translateY(-50%);
    z-index: 2;
    font-size: 21px;
    ${p => p.theme.sm.max(css`
        display: none;
    `)}
`;